import React from 'react'
import { DiaperBankPublic } from '../../utils/DiaperBankDTO'
import getDiaperDuration from '../../utils/diaperDuration'

const currencyFormatterRounded = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
})

export default function ProgressMeter({ diaperBank }: { diaperBank: DiaperBankPublic }) {
  let percentage = diaperBank.fundsRaised / diaperBank.fundsGoal
  if (percentage > 1) percentage = 1

  const diaperDuration = getDiaperDuration(diaperBank.fundsRaised, diaperBank.store)

  return (
    <div className='my-6 mx-4'>
      <div className='flex mb-4'>
        <div className='relative flex-grow mr-2'>
          <div className='bg-gray-100 border border-gray-600 rounded-full absolute top-0 left-0 h-6 opacity-30 w-full'></div>
          <div
            className='absolute top-0 left-0 h-6 rounded-full rounded-r-none'
            style={{ width: `${percentage * 100}%`, background: `url(/footprints.png) repeat-x left center`, backgroundSize: '20px', backgroundColor: '#cba3d8' }}
          ></div>
          <div className='absolute -top-2' style={{ left: `calc(${(percentage === 1 ? 0.95 : percentage) * 100}% - 1em)` }}>
            <img src='/baby.png' className='h-10' />
          </div>
        </div>
        <div className='flex-none w-6'>
          <img src='/baby-diaper.png' className='h-6' />
        </div>
      </div>

      <div className='font-thin text-sm flex'>
        <div className='flex-grow'>
          <span className='text-lg font-semibold'>{currencyFormatterRounded.format(diaperBank.fundsRaised)}</span> raised
          <br />
          {currencyFormatterRounded.format(diaperBank.fundsGoal)} goal
        </div>
        {diaperDuration.duration > 0 && (
          <div className='flex-grow text-right'>
            <span className='text-lg font-semibold'>{diaperDuration.duration}</span> {diaperDuration.unit}
            <br /> of diapers
          </div>
        )}
      </div>
    </div>
  )
}
